<template>
    <div class="accordion-block-item">
      <div class="accordion-block-header pointer" @click="toggleAccordion">
        <span class="accordeon-chevro">
          <mdicon v-if="isOpen" name="chevron-down" width="17px"/>
          <mdicon v-else name="chevron-up" width="17px"/>
        </span>
        <div class="line-text">{{ title }}</div>
        <div v-if="type == 'goods'" class="flex-right-block">
          <!-- Общий вес заказа. Должен рассчитываться при изменении в полях Д10.  
          Равен сумме весов каждой строки. Вес по строке должен считаться как Item.Weight х Д10 -->
          <div class="container-acc-header">
            Вес: 
            <span v-if="weight == 0" class="order-color-date small-goods-block-header">0.00 кг</span>
            <span v-else class="order-color-date small-goods-block-header">{{ weight }} кг</span>
          </div>
          <!-- Процент загрузки машины. Должен рассчитываться в процессе исполнения алгоритма 
          расчета стоимости (п. 8.1). 
          Значение должно округляться до целого.
          Если выбран самовывоз, не рассчитывать и не выводить. -->
          <div class="container-acc-header">
            Загрузка: 
            <span class="order-color-date small-goods-block-header">{{ load }} %</span>
          </div>
          <!-- Должна автоматически пересчитываться при изменении значений в полях Д10.  
          Должно равняться сумме полей Д14. -->
          <div class="container-acc-header">
            Итого: 
            <span v-if="summ == 0" class="order-color-date small-goods-block-header">0.00 руб.</span>
            <span v-else class="order-color-date small-goods-block-header">{{ summ }} руб.</span>
          </div>
        </div> 
        <div v-if="carId > 1" class="icon-block-header header-icon">
          <span class="close-icon" title="Удалить машину" @click.stop="delCar()">
            <mdicon name="close" width="22" height="22"/> 
          </span>
        </div>
      </div>
      <div class="accordion-block-content" v-show="isOpen" :style="computedStyles">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AccordionComponent',

    emits: [
      'delCar'
    ],

    props: {
      title: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: ''
      },
      weight: {
        type: [String, Number],
        default: 0
      },
      load: {
        type: [String, Number],
        default: 0
      },
      summ: {
        type: [String, Number],
        default: 0
      },
      openBlock: {
        type: Boolean,
        default: true
      },
      carId: {
        type: [String, Number],
        default: null
      },
    },

    data() {
      return {
        isOpen: true,
        load1: ""
      };
    },

    mounted() {
      this.isOpen = this.openBlock
      if(this.load == null || this.load == 0)
        this.load1 = 0
      else
        this.load1 = this.load

    },

    methods: {
      toggleAccordion() {
        this.isOpen = !this.isOpen;
      },

      delCar() {
        this.$emit('delCar', this.carId)
      }
    },

    computed: {
      computedStyles() {
        return {
          padding: this.type === 'goods' ? '0' : '10px'
        };
      }
    },
  };
  </script>